import React, { useState } from "react";

function LogTable({ logs, entityType}) {
  const [filters, setFilters] = useState({
    correlationId: "",
    entityId: "",
    status: "",
    result: "",
    message: "",
    severity: "",
    origin: "",
    timestamp: "",
  });

  const normalizeId = (v) => v ? v.replace(/^0+(?!$)/, "") : "";

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  // Perform filtering
  const filteredLogs = logs.filter((log) => {
    return (
      (log.correlationId || "").toLowerCase().includes(filters.correlationId.toLowerCase()) &&
      

 normalizeId(
  entityType === "ARTICLE"
    ? (log.articleId || log.bomId || "")
    : entityType === "SUPPLIER"
    ? (log.supplierNumber || log.bomId || "")
    : (log.bomId || "")
).toLowerCase().includes(
  normalizeId(filters.entityId).toLowerCase()
) &&
      (log.status || "").toLowerCase().includes(filters.status.toLowerCase()) &&
      (log.result || "").toLowerCase().includes(filters.result.toLowerCase()) &&
      (log.message || "").toLowerCase().includes(filters.message.toLowerCase()) &&
      (log.severity || "").toLowerCase().includes(filters.severity.toLowerCase()) &&
      (log.origin || "").toLowerCase().includes(filters.origin.toLowerCase()) &&
      (log.timestamp || "").toLowerCase().includes(filters.timestamp.toLowerCase())
    );
  });

  return (
    <table className="log-table">
      <thead>
        <tr>
          <th>Correlation ID</th>
          <th>

  {entityType === "ARTICLE"

    ? "Article ID"

    : entityType === "SUPPLIER"

    ? "Supplier ID"

    : "BOM ID"}

</th>
          <th>Status</th>
          <th>Result</th>
          <th>Message</th>
          <th>Severity</th>
          <th>Origin</th>
          <th>Timestamp</th>
        </tr>

        {/*  FILTER ROW */}
        <tr className="filter-row">
          <th>
            <input
              name="correlationId"
              placeholder="Filter..."
              value={filters.correlationId}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="entityId"
              placeholder="Filter..."
              value={filters.entityId}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="status"
              placeholder="Filter..."
              value={filters.status}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="result"
              placeholder="Filter..."
              value={filters.result}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="message"
              placeholder="Filter..."
              value={filters.message}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="severity"
              placeholder="Filter..."
              value={filters.severity}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="origin"
              placeholder="Filter..."
              value={filters.origin}
              onChange={handleFilterChange}
            />
          </th>
          <th>
            <input
              name="timestamp"
              placeholder="Filter..."
              value={filters.timestamp}
              onChange={handleFilterChange}
            />
          </th>
        </tr>
      </thead>

      <tbody>
        {filteredLogs.map((log, idx) => (
          <tr key={idx} className={`sev-${log.severity}`}>
            <td>{log.correlationId}</td>
            <td>

  {entityType === "ARTICLE"

    ? (log.articleId || log.bomId)

    : entityType === "SUPPLIER"

    ? (log.supplierNumber || log.bomId)

    : log.bomId}

</td>
            <td>{log.status}</td>
            <td>
              <span className={`status-badge status-${log.result}`}>
                {log.result}
              </span>
            </td>
            <td>{log.message}</td>
            <td>{log.severity}</td>
            <td>{log.origin}</td>
            <td>{log.timestamp}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default LogTable;
